export const jsonTexts = {
  "locale": "cn",
  "ver": "20191117",
  "langs": {
    "cn": "简中",
    "tw": "繁中",
    "en": "English",
    "jp": "日本語",
    "kr": "한국어",
  },
  "servers": {
    "cn": "简",
    "tw": "繁",
    "en": "En",
    "jp": "日",
    "kr": "한국",
  },
  "messages": {
    "cn": {
      "title": "少女前线签名图生成器",
      "tutorial": "建议使用 Firefox 或 Chrome 访问。<br/>渲染卡的话可以试试清除浏览器缓存再刷新。<br/>使用中遇到程序错误或有任何建议，请到 <a href='https://github.com/fc4soda/gfBadge'>github</a> 或 <a href='https://bbs.nga.cn/read.php?tid=18388732'>nga</a> 反馈。",
      "canvasSwitch": {
        "options": [
          { "text": "心智升级", "value": "mod" },
          { "text": "海报", "value": "poster" }
        ]
      },
      "versionChanged": "版本已更新。您可能需要重新设置某些内容。",
      "selectLang": "语言",
      "selectServer": "服务器",
      "thumbnail": "缩略图",
      "btnUpdate": "更新数据",
      "btnSaveCfg": "保存配置",
      "btnLoadCfg": "读取配置",
      "btnSaveCfgJSON": "导出配置",
      "btnLoadCfgJSON": "导入配置",
      "btnExportPNG": "保存为图片",
      "rightClickToSave": "请右键点击图片手动保存",
      "btnToTop": "回顶部",
      "tabGeneral": {
        "title": "指挥官信息",
        "name": "指挥官名称",
        "uid": "UID",
        "nameDefault": "无名",
        "level": "Lv.",
        "server": {
          "name": "所属服务器",
          "nameDefault": "未知服务器",
          "customServer": "自定义服务器名称",
          "options": [
            { "text": "安卓 0 服", "value": "安卓 0 服" },
            { "text": "IOS 0 服", "value": "IOS 0 服" },
            { "text": "Bilibili 0 服", "value": "Bilibili 0 服" },
            { "text": "繁中服", "value": "繁中服" },
            { "text": "日服", "value": "日服" },
            { "text": "韩服", "value": "韩服" },
            { "text": "美服", "value": "美服" }
          ]
        },
        "avatar": {
          "name": "自定义头像",
          "clear": "清除",
          "select": "选择图片或拖拽图片到此处"
        }
      },
      "tabTeam": {
        "title": "选择副官",
        "showAdjutant": "显示副官",
        "damaged": "重创"
      },
      "tabMod": {
        "title": "三改进度"
      },
      "tabPoster": {
        "title": "图鉴进度"
      },
      "tabBackground": {
        "title": "选择背景图片"
      },
      "tabAdjust": {
        "title": "调整与自定义",
        "display": "显示",
        "highResolution": "高清晰度",
        "dataStamp": "日期",
        "stats": "统计",
        "statsForEX": "统计量包括特典人形",
        "statsForSF": "统计量包括融合势力",
        "adjutantOffset": "副官",
        "adjutantOffsetX": "水平偏移",
        "adjutantOffsetY": "垂直偏移",
        "adjutantScaleFactor": "图片缩放",
        "adjutantCustom": "自定义副官",
        "adjutantCustomImg": "自定义副官图片",
        "adjutantCustomOffsetX": "水平偏移",
        "adjutantCustomOffsetY": "垂直偏移",
        "adjutantCustomScaleFactor": "图片缩放",
        "background": "背景图片",
        "backgroundOffsetX": "水平偏移",
        "backgroundOffsetY": "垂直偏移",
        "backgroundScaleFactor": "图片缩放",
        "backgroundAplha": "透明度",
        "backgroundCustom": "自定义背景",
        "backgroundCustomImg": "自定义背景图片",
        "backgroundCustomOffsetX": "水平偏移",
        "backgroundCustomOffsetY": "垂直偏移",
        "backgroundCustomScaleFactor": "图片缩放",
        "backgroundCustomAlpha": "图片透明度",
        "backgroundCustomStretch": "拉伸",
        "other": "其它",
        "gunLiteBackgroundAlpha": "枪格背景透明度"

      },
      "message": {
        "loadPictures": "图片加载中...",
        "loadFailed": "图片加载失败...",
        "loadDone": "加载完成",
        "loadPage": "页面加载中...",
        "generatePicture": "生成图片中...",
        "generateDone": "生成图片完成",
        "saveCfg": "保存配置中...",
        "saveCfgDone": "保存配置完成",
        "loadCfg": "加载配置中...",
        "loadCfgDone": "加载配置完成",
        "loadCfgTime": "加载的配置创建于",
        "loadCfgEmpty": "加载的配置为空!",
        "sw": "发现了签名图生成器的新版本（可能包含新人形或是错漏修复）。是否更新缓存使用新版本？",
      },
      "ui": {
        "selectTypeAll": "全选",
        "deselectTypeAll": "取消全选",
        "selectAll": "全选所有",
        "visitCount": "总访问量",
        "saveCfgTip": "保存到浏览器缓存",
        "loadCfgTip": "从浏览器缓存读取",
        "saveCfgJSONTip": "保存为配置文件",
        "loadCfgJSONTip": "从文件读取配置",
        "swCancel": "本次保持旧版本",
        "swLoad": "加载新版本",
      },
    },
    "tw": {
      "title": "少女前線簽名圖生成器",
      "tutorial": "建議使用 Firefox 或 Chrome 訪問。 <br/>渲染卡的話可以試試清除瀏覽器緩存再刷新。 <br/>使用中遇到程序錯誤或有任何建議，請到<a href='https://github.com/fc4soda/gfBadge'>github</a> 或<a href='https:// bbs.nga.cn/read.php?tid=18388732'>nga</a> 反饋。",
      "canvasSwitch": {
        "options": [
          { "text": "心智升級", "value": "mod" },
          { "text": "海報", "value": "poster" }
        ]
      },
      "versionChanged": "版本已更新。您可能需要重新設置某些內容。",
      "selectLang": "語言",
      "selectServer": "伺服器",
      "thumbnail": "縮略圖",
      "btnUpdate": "更新數據",
      "btnSaveCfg": "保存配置",
      "btnLoadCfg": "讀取配置",
      "btnSaveCfgJSON": "導出配置",
      "btnLoadCfgJSON": "導入配置",
      "btnExportPNG": "保存為圖片",
      "rightClickToSave": "請右鍵點擊圖片手動保存",
      "btnToTop": "回頂部",
      "tabGeneral": {
        "title": "指揮官信息",
        "name": "指揮官名稱",
        "uid": "UID",
        "nameDefault": "無名",
        "level": "Lv.",
        "server": {
          "name": "所屬伺服器",
          "nameDefault": "未知伺服器",
          "customServer": "自定義伺服器名稱",
          "options": [
            { "text": "安卓 服", "value": "安卓 服" },
            { "text": "IOS 服", "value": "IOS 服" },
            { "text": "Bilibili 服", "value": "Bilibili 服" },
            { "text": "繁中服", "value": "繁中服" },
            { "text": "日服", "value": "日服" },
            { "text": "韓服", "value": "韓服" },
            { "text": "美服", "value": "美服" }
          ]
        },
        "avatar": {
          "name": "自定義頭像",
          "clear": "清除",
          "select": "選擇圖片或拖拽圖片到此處"
        }
      },
      "tabTeam": {
        "title": "選擇副官",
        "showAdjutant": "顯示副官",
        "damaged": "重創"
      },
      "tabMod": {
        "title": "三改進度"
      },
      "tabPoster": {
        "title": "圖鑑進度"
      },
      "tabBackground": {
        "title": "選擇背景圖片"
      },
      "tabAdjust": {
        "title": "調整與自定義",
        "display": "顯示",
        "highResolution": "高清晰度",
        "dataStamp": "日期",
        "stats": "統計",
        "statsForEX": "統計量包括特典人形",
        "statsForSF": "統計量包括融合勢力",
        "adjutantOffset": "副官",
        "adjutantOffsetX": "水平偏移",
        "adjutantOffsetY": "垂直偏移",
        "adjutantScaleFactor": "圖片縮放",
        "adjutantCustom": "自定義副官",
        "adjutantCustomImg": "自定義副官圖片",
        "adjutantCustomOffsetX": "水平偏移",
        "adjutantCustomOffsetY": "垂直偏移",
        "adjutantCustomScaleFactor": "圖片縮放",
        "background": "背景圖片",
        "backgroundOffsetX": "水平偏移",
        "backgroundOffsetY": "垂直偏移",
        "backgroundScaleFactor": "圖片縮放",
        "backgroundAplha": "透明度",
        "backgroundCustom": "自定義背景",
        "backgroundCustomImg": "自定義背景圖片",
        "backgroundCustomOffsetX": "水平偏移",
        "backgroundCustomOffsetY": "垂直偏移",
        "backgroundCustomScaleFactor": "圖片縮放",
        "backgroundCustomAlpha": "圖片透明度",
        "backgroundCustomStretch": "拉伸",
        "other": "其它",
        "gunLiteBackgroundAlpha": "槍格背景透明度"
      },
      "message": {
        "loadPictures": "圖片加載中...",
        "loadFailed": "圖片無法加載...",
        "loadDone": "加載完成",
        "loadPage": "頁面加載中...",
        "generatePicture": "生成圖片中...",
        "generateDone": "生成圖片完成",
        "saveCfg": "保存配置中...",
        "saveCfgDone": "保存配置完成",
        "loadCfg": "加載配置中...",
        "loadCfgDone": "加載配置完成",
        "loadCfgTime": "加載的配置創建於",
        "loadCfgEmpty": "加載的配置為空!",
        "sw": "發現了簽名圖生成器的新版本（可能包含新人形或是錯漏修復）。是否更新緩存使用新版本？",
      },
      "ui": {
        "selectTypeAll": "全選",
        "deselectTypeAll": "取消全選",
        "selectAll": "全選所有",
        "visitCount": "總訪問量",
        "saveCfgTip": "保存到瀏覽器緩存",
        "loadCfgTip": "從瀏覽器緩存讀取",
        "saveCfgJSONTip": "保存為配置文件",
        "loadCfgJSONTip": "從文件讀取配置",
        "swCancel": "本次保持舊版本",
        "swLoad": "加載新版本",
      },
    },
    "en": {
      "title": "GF Badge",
      "tutorial": "It is recommended to use Google Chrome or Firefox to access this website.<br/>Feedback at <a href='https://github.com/fc4soda/gfBadge'>github[en]</a> or <a href='https://bbs.nga.cn/read.php?tid=18388732'>nga[zh-cn]</a>.",
      "canvasSwitch": {
        "options": [
          { "text": "Neural Upgrade", "value": "mod" },
          { "text": "Poster", "value": "poster" }
        ]
      },
      "versionChanged": "The software has been updated. Some settings might have been lost.",
      "selectLang": "Language",
      "selectServer": "Server",
      "thumbnail": "Thumbnail",
      "btnUpdate": "Update Data",
      "btnSaveCfg": "Save Config",
      "btnLoadCfg": "Load Config",
      "btnSaveCfgJSON": "Save JSON Config",
      "btnLoadCfgJSON": "Load JSON Config",
      "btnExportPNG": "Save Image",
      "rightClickToSave": "Please right click on the image and save manually",
      "btnToTop": "Top",
      "tabGeneral": {
        "title": "General",
        "name": "Name",
        "uid": "UID",
        "nameDefault": "NONAME",
        "level": "Lv.",
        "server": {
          "name": "Server",
          "customServer": "Custom Server Name",
          "nameDefault": "Unknow Server",
          "options": [
            { "text": "Android Server", "value": "Android Server" },
            { "text": "IOS Server", "value": "IOS Server" },
            { "text": "Bilibili Server", "value": "Bilibili Server" },
          ]
        },
        "avatar": {
          "name": "Avatar",
          "clear": "Clear",
          "select": "Select Avatar"
        }
      },
      "tabTeam": {
        "title": "Team",
        "showAdjutant": "Show Adjutant",
        "damaged": "Damaged"
      },
      "tabMod": {
        "title": "Mod"
      },
      "tabPoster": {
        "title": "Poster"
      },
      "tabBackground": {
        "title": "Background"
      },
      "tabAdjust": {
        "title": "Adjust",
        "display": "Display",
        "highResolution": "Higher Resolution",
        "dataStamp": "Date",
        "stats": "Stats",
        "statsForEX": "Include Extra T-Dolls in Stats",
        "statsForSF": "Include Assimilable Units in Stats",
        "adjutantOffset": "Adjutant Offset",
        "adjutantOffsetX": "Adjutant Offset X",
        "adjutantOffsetY": "Adjutant Offset Y",
        "adjutantScaleFactor": "Adjutant Scale Factor",
        "adjutantCustomImg": "Custom Adjutant Image",
        "background": "Background",
        "backgroundOffsetX": "Background Offset X",
        "backgroundOffsetY": "Background Offset Y",
        "backgroundScaleFactor": "Background Scale Factor",
        "backgroundAplha": "Background Alpha",
        "gunLiteBackgroundAlpha": "Gun Background Alpha",
        "backgroundCustomImg": "Custom Background Image",
        "backgroundCustomOffsetX": "Custom Background Image Offset X",
        "backgroundCustomOffsetY": "Custom Background Image Offset Y",
        "backgroundCustomScaleFactor": "Custom Background Scale Factor",
        "backgroundCustomAlpha": "Custom Background Image Alpha",
        "backgroundCustomStretch": "Custom Background Image Stretch",
        "other": "Others"
      },
      "message": {
        "loadPictures": "Loading Pictures...",
        "loadFailed": "Pictures Failed To Load...",
        "loadDone": "Loaded",
        "loadPage": "Loading Page...",
        "generatePicture": "Generating Picture...",
        "generateDone": "Generated",
        "saveCfg": "Saving Config...",
        "saveCfgDone": "Config Saved",
        "loadCfg": "Loading Config...",
        "loadCfgDone": "Config Loaded",
        "loadCfgTime": "Loaded config created at",
        "loadCfgEmpty": "Loaded configuration is empty!",
        "sw": "A new version of GF Badge has been released (probably containing new doll data or bug fixes). Do you want to update the cache to the newer version?",
      },
      "ui": {
        "selectTypeAll": "Select All",
        "deselectTypeAll": "Uncheck All",
        "selectAll": "Select All Guns",
        "visitCount": "Visit",
        "saveCfgTip": "Save to browser cache",
        "loadCfgTip": "Load from browser cache",
        "saveCfgJSONTip": "Save to config file",
        "loadCfgJSONTip": "Load from config file",
        "swCancel": "Not this time",
        "swLoad": "Update to the version",
      },
    },
    "jp": {
      "title": "ドールズフロントライン バッジジェネレータ",
      "tutorial": "FirefoxまたはChromeを使用することをお勧めします。<br/>カードをレンダリングする場合,ブラウザーのキャッシュをクリアして更新してください。<br/>使用中にプログラムエラーまたは提案が発生した場合は,<a href = 'https://github.com/fc4soda/gfBadge'>github </a>または<a href='https://bbs.nga.cn/read.php?tid=18388732'> nga </a>フィードバック。 ",
      "canvasSwitch": {
        "options": [
          { "text": "マインドアップグレード", "value": "mod" },
          { "text": "ポスター", "value": "poster" }
        ]
      },
      "versionChanged": "ソフトウェアが更新されました。いくつかの設定が失われた可能性があります。",
      "selectLang": "言語",
      "selectServer": "サーバー",
      "thumbnail": "プレビュー",
      "btnUpdate": "データ更新",
      "btnSaveCfg": "構成の保存",
      "btnLoadCfg": "設定の読み取り",
      "btnSaveCfgJSON": "構成のエクスポート",
      "btnLoadCfgJSON": "構成のインポート",
      "btnExportPNG": "画像として保存",
      "rightClickToSave": "画像を右クリックして手動で保存してください",
      "btnToTop": "トップに戻る",
      "tabGeneral": {
        "title": "指揮官情報",
        "name": "指揮官名",
        "uid": "UID",
        "nameDefault": "無名",
        "level": "Lv。",
        "server": {
          "name": "所有サーバー",
          "nameDefault": "不明なサーバー",
          "customServer": "カスタムサーバー名",
          "options": [
            { "text": "Android サービス", "value": "Android サービス" },
            { "text": "IOS サーバー", "value": "IOS サーバー" },
            { "text": "中国サーバー", "value": "中国サーバー" },
          ]
        },
        "avatar": {
          "name": "カスタムアバター",
          "clear": "クリア",
          "select": "ここで画像を選択またはドラッグします"
        }
      },
      "tabTeam": {
        "title": "副官",
        "showAdjutant": "副官表示",
        "damaged": "重傷"
      },
      "tabMod": {
        "title": "MOD3進度"
      },
      "tabPoster": {
        "title": "図鑑進度"
      },
      "tabBackground": {
        "title": "背景画像を選択"
      },
      "tabAdjust": {
        "title": "調整とカスタマイズ",
        "display": "画面",
        "highResolution": "高解像度",
        "dataStamp": "日付",
        "stats": "統計",
        "statsForEX": "統計で特典人形を含みます",
        "statsForSF": "Include Assimilable Units in Stats",
        "adjutantOffset": "アジュバント",
        "adjutantOffsetX": "水平オフセット",
        "adjutantOffsetY": "垂直オフセット",
        "adjutantScaleFactor": "画像ズーム",
        "adjutantCustom": "カスタムアジュバント",
        "adjutantCustomImg": "カスタムアジュバント画像",
        "adjutantCustomOffsetX": "水平オフセット",
        "adjutantCustomOffsetY": "垂直オフセット",
        "adjutantCustomScaleFactor": "画像スケール",
        "background": "背景画像",
        "backgroundOffsetX": "水平オフセット",
        "backgroundOffsetY": "垂直オフセット",
        "backgroundScaleFactor": "画像スケール",
        "backgroundAplha": "透明度",
        "backgroundCustom": "カスタム背景",
        "backgroundCustomImg": "カスタム背景画像",
        "backgroundCustomOffsetX": "水平オフセット",
        "backgroundCustomOffsetY": "垂直オフセット",
        "backgroundCustomScaleFactor": "画像スケール",
        "backgroundCustomAlpha": "画像の透明度",
        "backgroundCustomStretch": "ストレッチ",
        "other": "その他",
        "gunLiteBackgroundAlpha": "銃の背景の透明度"
      },
      "message": {
        "loadPictures": "画像の読み込み中...",
        "loadFailed": "画像が読み込まれませんでした...",
        "loadDone": "ロード完了",
        "loadPage": "ページの読み込み中...",
        "generatePicture": "画像の生成...",
        "generateDone": "画像生成完了",
        "saveCfg": "設定を保存しています...",
        "saveCfgDone": "設定の保存が完了しました",
        "loadCfg": "設定を読み込んでいます...",
        "loadCfgDone": "ロード設定が完了しました",
        "loadCfgTime": "ロードされた構成が作成されました",
        "loadCfgEmpty": "プロファイルがありません",
        "sw": "新しいバージョンがリリースされました（おそらく新しい人形データやバグ修正を含む）。キャッシュを新しいバージョンに更新しますか？",
      },
      "ui": {
        "selectTypeAll": "すべて選択",
        "deselectTypeAll": "選択解除",
        "selectAll": "すべて選択",
        "visitCount": "合計訪問数",
        "saveCfgTip": "ブラウザキャッシュに保存",
        "loadCfgTip": "ブラウザキャッシュから読み取り",
        "saveCfgJSONTip": "設定ファイルとして保存",
        "loadCfgJSONTip": "ファイルから構成を読み取る",
        "swCancel": "まだ今度",
        "swLoad": "バージョンを更新する",
      },
    },
    "kr": {
      "title": "Girls' Frontline Signature Creator",
      "tutorial": "Firefox 또는 Chrome을 사용하는 것이 좋습니다. <br/> 카드를 렌더링하는 경우 브라우저 캐시를 지우고 새로 고칠 수 있습니다. <br/> 사용 중에 프로그램 오류 또는 제안 사항이 있으면 <a href = 'https://github.com/fc4soda/gfBadge'>github </a> 또는 <a href='https://bbs.nga.cn/read.php?tid=18388732'> nga </a> 피드백 ",
      "canvasSwitch": {
        "options": [
          { "text": "마음 업그레이드", "value": "mod" },
          { "text": "포스터", "value": "poster" }
        ]
      },
      "versionChanged": "소프트웨어가 업데이트되었습니다. 일부 설정이 손실되었을 수 있습니다.",
      "selectLang": "언어",
      "selectServer": "서버",
      "thumbnail": "미리보기",
      "btnUpdate": "업데이트 데이터",
      "btnSaveCfg": "구성 저장",
      "btnLoadCfg": "구성 읽기",
      "btnSaveCfgJSON": "내보내기 구성",
      "btnLoadCfgJSON": "가져 오기 구성",
      "btnExportPNG": "그림으로 저장",
      "rightClickToSave": "이미지를 마우스 오른쪽 버튼으로 클릭하고 수동으로 저장하십시오",
      "btnToTop": "맨 위로 이동",
      "tabGeneral": {
        "title": "사령관 정보",
        "name": "사령관 이름",
        "uid": "UID",
        "nameDefault": "알 수 없음",
        "level": "Lv.",
        "server": {
          "name": "소유 서버",
          "nameDefault": "알 수없는 서버",
          "customServer": "사용자 정의 서버 이름",
          "options": [
            { "text": "Android 서비스", "value": "Android 서비스" },
            { "text": "IOS 서버", "value": "IOS 서버" },
            { "text": "한복", "value": "한복" },
            { "text": "미국 서비스", "value": "미국 서비스" }
          ]
        },
        "avatar": {
          "name": "맞춤 아바타",
          "clear": "클리어",
          "select": "여기에서 이미지를 선택하거나 드래그하십시오"
        }
      },
      "tabTeam": {
        "title": "중위 선택",
        "showAdjutant": "중위 선택",
        "damaged": "중상"
      },
      "tabMod": {
        "title": "3 가지 개선"
      },
      "tabPoster": {
        "title": "그림 진행 상황"
      },
      "tabBackground": {
        "title": "배경 이미지 선택"
      },
      "tabAdjust": {
        "title": "조정 및 사용자 정의",
        "display": "화면 설정",
        "highResolution": "높은 해상도",
        "dataStamp": "날짜",
        "stats": "통계",
        "statsForEX": "통계에 “EX T-Doll” 을 포함하십시오",
        "statsForSF": "통계에 “혼합세력” 을 포함하십시오",
        "adjutantOffset": "Adjutant",
        "adjutantOffsetX": "가로 오프셋",
        "adjutantOffsetY": "수직 오프셋",
        "adjutantScaleFactor": "이미지 줌",
        "adjutantCustom": "사용자 지정 Adjutant",
        "adjutantCustomImg": "사용자 지정 Adjutant 그림",
        "adjutantCustomOffsetX": "가로 오프셋",
        "adjutantCustomOffsetY": "수직 오프셋",
        "adjutantCustomScaleFactor": "이미지 스케일",
        "background": "배경 이미지",
        "backgroundOffsetX": "가로 오프셋",
        "backgroundOffsetY": "수직 오프셋",
        "backgroundScaleFactor": "이미지 스케일",
        "backgroundAplha": "투명도",
        "backgroundCustom": "맞춤 배경",
        "backgroundCustomImg": "맞춤 배경 이미지",
        "backgroundCustomOffsetX": "가로 오프셋",
        "backgroundCustomOffsetY": "수직 오프셋",
        "backgroundCustomScaleFactor": "이미지 스케일",
        "backgroundCustomAlpha": "이미지 투명도",
        "backgroundCustomStretch": "스트레치",
        "other": "기타",
        "gunLiteBackgroundAlpha": "총 배경 투명도"

      },
      "message": {
        "loadPictures": "사진로드 중 ...",
        "loadFailed": "그림을로드하지 못했습니다...",
        "loadDone": "로드 완료",
        "loadPage": "페이지로드 중 ...",
        "generatePicture": "사진 생성 중 ...",
        "generateDone": "사진 생성 완료",
        "saveCfg": "구성 저장 중 ...",
        "saveCfgDone": "구성 저장 완료",
        "loadCfg": "구성로드 중 ...",
        "loadCfgDone": "로드 구성 완료",
        "loadCfgTime": "로드 된 구성이 작성되었습니다",
        "loadCfgEmpty": "프로필이 없습니다!",
        "sw": "새 버전이 출시되었습니다 (아마도 새로운 인형 데이터 또는 버그 수정 사항이 포함되어 있음). 캐시를 최신 버전으로 업데이트 하시겠습니까?",
      },
      "ui": {
        "selectTypeAll": "모두 선택",
        "deselectTypeAll": "모두의 선택을 취소합니다",
        "selectAll": "모두 선택",
        "visitCount": "총 방문수",
        "saveCfgTip": "브라우저 캐시에 저장",
        "loadCfgTip": "브라우저 캐시에서 읽기",
        "saveCfgJSONTip": "구성 파일로 저장",
        "loadCfgJSONTip": "파일에서 구성 읽기",
        "swCancel": "이번에는 아닙니다",
        "swLoad": "버전으로 업데이트하십시오",
      },
    }
  }
}
